import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';

import styles from './CustomButton.module.scss';

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  direction?: 'next' | 'prev';
  clickHandler?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const CustomButton: React.FunctionComponent<Props> = ({
  className,
  direction,
  clickHandler,
  ...props
}) => (
  <button
    type="button"
    className={classNames(styles.button, className)}
    color="blue600"
    aria-label={direction === 'next' ? 'Próximo slide' : 'Slide anterior'}
    {...props}
    onClick={clickHandler}
  >
    <FontAwesomeIcon icon={direction === 'next' ? faArrowRight : faArrowLeft} />
  </button>
);

export default CustomButton;
